'use es6';

import { List } from 'immutable';
import I18n from 'I18n';
import { renderToString } from 'react-dom/server';
import { getProperty, getPropertyLabel, getReference } from 'reporting-data/v2/dataset/datasetRecords';
import { AxisTypes, MarkTypes } from '../../xyRecords';
import { getPropertyFormatter } from '../../../../formatters/propertyFormatter';
import { TooltipBodyListContainer, TooltipBodyLabel, TooltipBodyValue, TooltipBody, CustomHighchartsTooltip, TooltipHeader } from '../../../../highcharts/options/customTooltipStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const formatHeader = (dataset, headerFieldKey, headerFieldValue) => {
  const property = getProperty(dataset, headerFieldKey);
  const reference = getReference(dataset, headerFieldKey, headerFieldValue);
  const referenceLabel = reference && reference.get('label');
  const valueLabel = referenceLabel || getPropertyFormatter(property)(headerFieldValue);
  return /*#__PURE__*/_jsx(TooltipHeader, {
    children: valueLabel
  });
};
const getCategoryFieldKeyFrom = (axisName, layer) => layer.getIn([axisName, 'type']) === AxisTypes.category && layer.getIn([axisName, 'field']);
const pointTooltip = ({
  series: __series,
  layer,
  point
}) => {
  const dataset = layer.get('dataset');
  const row = point.get('row');
  const xFieldKey = layer.getIn(['x', 'field']);
  const yFieldKey = layer.getIn(['y', 'field']);
  const colorFieldKey = layer.getIn(['color', 'field']);
  const sizingFieldKey = layer.getIn(['sizing', 'field']);
  const detailFieldKey = layer.getIn(['detail', 'field']);
  const markType = layer.getIn(['mark', 'type']);

  // order matters: highest ==> lowest preference
  const inferredHeaderFieldKey = getCategoryFieldKeyFrom('x', layer) || getCategoryFieldKeyFrom('y', layer) || detailFieldKey || colorFieldKey;
  const tooltipBodyFields = List([xFieldKey, yFieldKey, colorFieldKey, sizingFieldKey, detailFieldKey]).filter(key => key && key !== inferredHeaderFieldKey);
  const body = tooltipBodyFields.map(field => {
    const property = getProperty(dataset, field);
    const fieldLabel = getPropertyLabel(dataset, field);
    const rawValueFromData = point.getIn(['row', field]);
    /**
     * If the mark type is arearange, then the data is an array of length 2
     * and should be displayed as a range, for example: 100-200.
     */
    const rawValue = markType === MarkTypes.arearange ? rawValueFromData.join(' - ') : rawValueFromData;
    const reference = getReference(dataset, field, rawValue);
    const referenceLabel = reference && reference.get('label');
    const valueLabel = referenceLabel || getPropertyFormatter(property)(rawValue);
    const normalizedValue = valueLabel === 'undefined' ? '-' : valueLabel;
    return /*#__PURE__*/_jsxs(TooltipBodyListContainer, {
      children: [/*#__PURE__*/_jsx(TooltipBodyLabel, {
        children: I18n.text('reporting-visualizations.tooltip.group', {
          group: I18n.SafeString(fieldLabel)
        })
      }), /*#__PURE__*/_jsx(TooltipBodyValue, {
        children: normalizedValue
      })]
    }, field);
  }).toList();
  const tooltip = /*#__PURE__*/_jsxs(CustomHighchartsTooltip, {
    children: [inferredHeaderFieldKey && formatHeader(dataset, inferredHeaderFieldKey, row.get(inferredHeaderFieldKey)), /*#__PURE__*/_jsx(TooltipBody, {
      children: body
    })]
  });
  return renderToString(tooltip);
};
export const getTooltipFormatter = ({
  chart,
  layers
}) => {
  const seriesMap = chart.get('series').toMap().mapKeys((_, series) => series.get('id'));
  const layerMap = layers.toMap().mapKeys((_, layer) => layer.get('id'));
  return function formatter() {
    const index = this.point.index;
    const series = seriesMap.get(this.series.userOptions.id);
    const layer = layerMap.get(this.series.userOptions.layerId);
    const points = seriesMap.get(this.series.userOptions.id).get('points');
    const point = points.get(index);
    return pointTooltip({
      series,
      layer,
      point
    });
  };
};